import React from 'react'
import { connect } from 'react-redux'
import Moment from 'react-moment'
import { ProgressBar } from '@blueprintjs/core'
import NumberFormat from 'react-number-format'
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome'
import ReactTable from 'react-table'
import { CustomButton } from 'components'
import { getPrintForm } from 'ducks/bankGuaranteeRequest'
import logo from 'assets/images/DTGO_logo_with_text.png'
import { CoverContainer, ContactPointContainer, AttachContainer } from './styled'
import './specialStyle.css'
import 'moment/locale/th';

const columns = [
  {
    Header: '',
    accessor: 'id',
    style: { display: 'flex', justifyContent: 'center' },
    width: 40,
    Cell: (row) => row.index + 1
  }, {
    Header: 'หนังสือค้ำประกัน',
    accessor: 'documentType',
    width: 120,
  }, {
    Header: 'ธนาคาร ',
    accessor: 'bankOwner',
  }, {
    Header: 'เลขที่',
    accessor: 'bgNumber',
  }, {
    Header: 'จำนวนเงิน (บาท)',
    accessor: 'amount',
    Cell: (row) => 
      <div>
        <NumberFormat value={row.value} displayType='text' thousandSeparator decimalScale={2} fixedDecimalScale />
      </div>,
    style: { textAlign: 'right', paddingRight: '10px' },
    width: 150,
  }
]

const BGPrintForm = (props) => {
  const { bgData, loading } = props
  const today = new Date()
  const months = 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_')
  const weekdays = 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_')

  const { appointmentReturnDate=new Date(), returnTime=new Date(), returnTimeTo=new Date() } = bgData

  React.useEffect(() => {
    if (props.match.params.id) {
      props.getPrintForm(props.match.params.id)
    }
  }, [])

  const rqType = bgData.requestType === 'change' ? ' เปลี่ยนหนังสือค้ำประกัน(BG) ' : ' รับคืนหนังสือค้ำประกัน(BG) '

  return (
    <CoverContainer>
      <div className='titleContent'>
        Bank Guarantee Print Form
        <div className='accessoriesContent'>
          <CustomButton disable={loading} icon='print' title='PRINT' btnColor='gray' onClick={() => window.print()} />
        </div>
      </div>
      <div className='pageContainer'>
        <div className='documentDataContainer'>
          <div className='headerContent'>
            {/* <div className='left'>
              <img src={logo} alt='' style={{ width: '160px', height: '71px' }} />
            </div> */}
            <div className='right'>
              <div className='t18b'>วันที่&nbsp;{today.getDate()} {months[today.getMonth()]} {today.getFullYear() + 543}</div>
            </div>
          </div>
          {/* <div className='t22b'>DT Group of Companies</div>
          <div className='separator' /> */}
          {loading ? <ProgressBar /> :
            <div>
              <div className='dataContent'>
                <div className='left'>
                <div className='row'>
                    <div className='t16b'>เรียน </div>
                    <div className='t16'>&nbsp;{bgData.vendor || ''}</div>
                  </div>
                  {/* <div className='row'>
                    <div className='t16b'>จาก </div>
                    <div className='t16'>&nbsp;{bgData.company || ''}</div>
                  </div> */}
                </div>
              </div>
              <div className='row' style={{ marginTop: '30px' }}>
                ตามที่&nbsp;{bgData.vendor || 'ท่าน'}&nbsp;ได้แจ้งความประสงค์เพื่อ{rqType}
                กับ&nbsp;{bgData.company || ''}&nbsp;ไว้ มีรายการดังนี้
              </div>
              <AttachContainer>
                <ReactTable
                  data={bgData.bgReturns || []}
                  columns={columns}
                  resizable={false}
                  minRows={1}
                  showPagination={false}
                  sortable={false}
                />
              </AttachContainer>
              <br />
              <div className='row'>
                โดยท่านสามารถติดต่อเพื่อ{rqType}ได้ ที่ส่วนการเงิน ณ สำนักงานบริษัทฯ
              </div>
              <div className='row'>
                695 หมู่ที่ 12 ต.บางแก้ว อ.บางพลี จ.สมุทรปราการ 10540 
              </div>
              <div className='row'>
                วัน{weekdays[appointmentReturnDate.getDay()]}ที่ {appointmentReturnDate.getDate()} {months[appointmentReturnDate.getMonth()]} พ.ศ. {appointmentReturnDate.getFullYear() + 543}&nbsp;
                เวลา {String(returnTime.getHours()).padStart(2, '0')}.{String(returnTime.getMinutes()).padStart(2, '0')}-
                {String(returnTimeTo.getHours()).padStart(2, '0')}.{String(returnTimeTo.getMinutes()).padStart(2, '0')} น.
              </div>
              <div className='row'>
                หากท่านไม่สามารถเข้ามารับได้ตามวันเวลาดังกล่าว 
              </div>
              <div className='row'>
                รบกวนติดต่อสอบถามการเงิน โทร.02-0886400 ต่อ 1331-1333
              </div>
              <div className='row' style={{ marginTop: '20px' }}>
                <b><u>เอกสารประกอบในการ{rqType}</u></b>
              </div>
              <ol>
                <li>สำเนาหนังสือค้ำประกันทุกฉบับ</li>
                <li>สำเนาจดหมายขอ{rqType}</li>
                <li>สำเนาบัตรประชาชนผู้มา{rqType}</li>
                {
                  bgData.requestType === 'change' ? <li>หนังสือค้ำประกันฉบับใหม่</li> : null
                }
              </ol>

            <div>จึงเรียนมาเพื่อทราบ</div><br />
            <div>{bgData.financeReviewName}</div>
            <div>การเงิน</div>
            <div>{bgData.financeReviewCompany}</div>
            <br /><br /><br />
            <div><b><u>ส่วนรับเอกสาร</u></b></div>
            <br /><br /><br />
            <div style={{ borderBottom: 'solid 1px #000000', width: '250px' }}></div>
            <div>{bgData.vendor}</div>
            <div><b>ได้รับ BG เป็นที่เรียบร้อยแล้ว</b></div>
            </div>
          }
        </div>
      </div>
    </CoverContainer>
  )
}

const mapStateToProps = (state) => ({
  bgData: state.bgRequest.printForm.data,
  loading: state.bgRequest.printForm.loading
})

const mapDispatchToProps = {
  getPrintForm
}

export default connect(mapStateToProps, mapDispatchToProps)(BGPrintForm)